
export default {
    name: 'profil',
    components: {},
    props: [],
    data() {
        return {
            personnel: {
                user_id: 0,
                nom: '',
                titre: '',
                email: '',
            },

            password: {
                user_id: 0,
                current_pwd: '',
                new_pwd: '',
                confirm_pwd: '',
            },

            is_loading: true,
            is_empty: false,
            save_loading: false,
            save_pwd_loading: false,
            user_is_existe: false,

            confirm_error: false,
            old_pwd_err: false
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        auth_user() {
            return this.$store.getters['auth_user'];
        },
    },

    mounted() {
        this.user_id = this.userCredentials.id
        

        this.refreshUserInfo() 

        this.fillUserInfo()

    },

    methods: {
        fillUserInfo() {
            this.personnel = {
                user_id: this.user_id,
                nom: this.auth_user.name,
                titre: this.auth_user.titre,
                email: this.auth_user.email,
            }
        },

        refreshUserInfo() {
            this.$store.dispatch('getAuthUser', { user_id: this.user_id }).then(() => {
                console.log(this.auth_user)
            })
        },

        async savePersonnel() {
            const isValid = await this.$refs.user_form.validate();
            if (!isValid) {
                return;
            }

            let data
            this.save_loading = true
            data = {
                user_id: this.personnel.user_id,
                nom: this.personnel.nom,
                titre: this.personnel.titre,
                email: this.personnel.email,
            }

            this.$store.dispatch('updateUserProfil', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.refreshUserInfo()
                    this.successToast("Modification effectué avec succès")

                } else if (response < 0) {
                    this.user_is_existe = true
                }

                this.save_loading = false
            })
        },

        async savePwd() {
            const isValid = await this.$refs.password_form.validate();

            if (!isValid) {
                return;
            }

            if (this.password.new_pwd != this.password.confirm_pwd) {
                this.confirm_error = true
                return;
            }

            let data
            this.save_pwd_loading = true
            data = {
                user_id: this.personnel.user_id,
                email: this.personnel.email,
                password: this.password.current_pwd,
                new_password: this.password.new_pwd,
            }

            this.$store.dispatch('updateUserPassword', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.successToast("Mot de passe modifié avec succès")

                    setTimeout(() => {
                        this.logout()
                    }, 2000);
                    
                } else {
                    this.old_pwd_err = true
                }

                this.save_pwd_loading = false
            })
        },

        clearError() {
            this.user_is_existe = false
            this.confirm_error = false
            this.old_pwd_err = false
        },

        resetVuexState() {
            const freshState = {};
            const modules = this.$store._modules.root._children || {};

            Object.keys(modules).forEach((moduleName) => {
                const module = modules[moduleName];
                const moduleState = typeof module.state === 'function' ? module.state() : module.state;

                freshState[moduleName] = moduleState && typeof moduleState === 'object'
                    ? { ...moduleState }
                    : moduleState;
            });

            this.$store.replaceState(freshState);
        },

        async logout()
        {
            this.resetVuexState();
            localStorage.removeItem('vuex');
            localStorage.clear();
            this.$router.push({"path": "/login"})
        },
    }
}


